import React from 'react';
import './WhatsAppButton.css';

// ─── CONFIGURE YOUR WHATSAPP NUMBER HERE ─────────────────────────────────────
// Format: country code + number, no + or spaces.  e.g. "16045551234"
const WHATSAPP_NUMBER = '17789091613';

const PRE_FILLED_MESSAGE =
  "Hi! I'm browsing iLOVEthisGAME.ca and have a question about Playermaker.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PRE_FILLED_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
      aria-label="Chat with us on WhatsApp"
      title="Chat on WhatsApp"
    >
      {/* Official WhatsApp icon */}
      <svg
        className="whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        aria-hidden="true"
      >
        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.601 2.326zm-5.607 12.1a6.57 6.57 0 0 1-3.351-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.556 6.556 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.342l-.381-.006c-.133 0-.348.05-.53.248-.183.199-.703.687-.703 1.676 0 .989.71 1.948.808 2.081.098.133 1.394 2.137 3.381 2.996.474.205.843.328 1.132.423.475.152.908.129 1.25.078.382-.057 1.17-.478 1.335-.94.165-.465.165-.864.116-.948-.049-.084-.182-.133-.38-.232z" />
      </svg>
      <span className="whatsapp-label">Chat on WhatsApp</span>
    </a>
  );
}
